import type { Collection } from "../lib/documentSearch/types";

type CollectionListProps = {
  collections: Collection[];
  selectedIds: string[];
  onToggle: (collectionId: string) => void;
};

export function CollectionList({
  collections,
  selectedIds,
  onToggle,
}: CollectionListProps) {
  return (
    <div className="collection-list">
      {collections.map((collection) => {
        const selected = selectedIds.includes(collection.id);
        return (
          <button
            className={`collection-item collection-item--${collection.accent} ${
              selected ? "is-selected" : ""
            }`}
            key={collection.id}
            type="button"
            onClick={() => onToggle(collection.id)}
            aria-pressed={selected}
          >
            <span className="collection-item__name">{collection.name}</span>
            <span className="collection-item__description">
              {collection.description}
            </span>
            <span className="collection-item__count">{collection.count}</span>
          </button>
        );
      })}
    </div>
  );
}
